import { Controparte } from "src/app/common/models/controparte";
import { Parte } from "src/app/common/models/parte";
import { TipoPersona } from "src/app/common/models/tipologiche/tipo-persona";
import { PropertiesSettings } from "src/app/core/configuration/properties-settings";
import { ElaborationDocumentFilterEntity } from "src/app/document-management/models/elaboration-doc-filter";
import { isNumeric } from "./wizard-utils";


export function setTempId(parte: Parte) {
  let PROPERTIES_SETTINGS = PropertiesSettings;
  if (!parte.id) {
    let tempID = 'TEMP_';
    if (parte.tipoPersona) {
      if (parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA) {
        tempID = tempID + parte.nome + parte.cognome + parte.codiceFiscale;
      } else if (parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA) {
        tempID = tempID + parte.ragioneSociale + parte.partitaIva;
      }
    }
    parte.id = tempID;
  }
  return parte;
}


export function parteFromEntity(entity: ElaborationDocumentFilterEntity, tipoPersonaOptions: TipoPersona[]): Parte {

  let parte: Parte;
  if (entity.valore && entity.uri) {
    parte = new Parte();
    if(entity.uri.includes("PDA")){
      entity.valore = entity.valore.substring(0, entity.valore.indexOf(" categoria"));
      let identificativo = entity.uri.substring(entity.uri.indexOf('_') + 1, entity.uri.length)
      if (identificativo?.length > 0 && isNumeric(identificativo)) {
        if(entity.valore.includes("ragioneSociale: ")){
          parte.ragioneSociale = entity.valore.replace("ragioneSociale: ","");
        } else {
          let ragioneSociale = entity.valore.replace("nome: ", "");
          ragioneSociale = ragioneSociale.replace("cognome: "," ");
          parte.ragioneSociale = ragioneSociale
          }
        parte.partitaIva = identificativo;
        if (tipoPersonaOptions && tipoPersonaOptions.length > 0) {
          parte.tipoPersona = tipoPersonaOptions[1];
        }
      } else {
        let nomeECognome = estraiNomeECognome(entity.valore);
        let nome = null;
        let cognome = null;
        if(nomeECognome && nomeECognome.length >= 0){
          nome = !!nomeECognome[1].trim().split(/\s+/).toString() ? nomeECognome[1].trim().split(/\s+/).toString() : null;
          cognome = !!nomeECognome[2].trim().split(/\s+/).toString() ? nomeECognome[2].trim().split(/\s+/).toString() : null;
        }
        parte.nome = nome && nome.trim() !== "-" ? nome.trim() : null;
        if(parte.nome === null  && identificativo === 'PDA'){//se ha solo il cognome e non è possibile risalire al CF o P.IVA è una persona giuridica
          let ragioneSociale = estraiRagioneSociale(entity.valore);
          parte.ragioneSociale = ragioneSociale;
        } else {
          parte.cognome = cognome && cognome.trim() !== "-" ? cognome.trim() : null;
        }
        if(checkCodiceFiscale(identificativo)){
          parte.codiceFiscale = identificativo;
        } else {
          parte.codiceFiscale = null;
        }
        if (tipoPersonaOptions && tipoPersonaOptions.length > 0) {
          if(parte.ragioneSociale !== null && parte.ragioneSociale !== undefined){
            parte.tipoPersona = tipoPersonaOptions[1];
          } else if(parte.nome && parte.nome !== null && parte.cognome && parte.cognome !== null ) {
            parte.tipoPersona = tipoPersonaOptions[0];
          } else {
            return null;
          }
      }
    }
    } else {
      let identificativo = entity.uri.substring(entity.uri.indexOf('_') + 1, entity.uri.length)
      if (identificativo?.length > 0 && isNumeric(identificativo)) {
        parte.ragioneSociale = entity.valore;
        parte.partitaIva = identificativo;
        if (tipoPersonaOptions && tipoPersonaOptions.length > 0) {
          parte.tipoPersona = tipoPersonaOptions[1];
        }
      } else {
        let nome = entity.valore.substring(0, entity.valore.indexOf(' '));
        let cognome = entity.valore.substring(entity.valore.indexOf(' '), entity.valore.length);
        parte.nome = nome.trim();
        parte.cognome = cognome.trim();
        if(checkCodiceFiscale(identificativo)){
          parte.codiceFiscale = identificativo;
        } else {
          parte.codiceFiscale = null;
        }
        if (tipoPersonaOptions && tipoPersonaOptions.length > 0) {
          parte.tipoPersona = tipoPersonaOptions[0];
        }
    }

    }
    parte = setTempId(parte);
  }

  return parte;
}

export function partiFromEntities(entities: ElaborationDocumentFilterEntity[], tipoPersonaOptions: TipoPersona[]){
  let out: Parte [] = [];
  if(entities &&  entities.length > 0){
    entities.forEach(entity => {
      out.push(parteFromEntity(entity,tipoPersonaOptions));
    });
  }
  return out;
}



export function isControparteAssociated(option: { isAssociable: boolean, isControparte: boolean, hasDetailsAnagrafica: boolean, anagrafica: any }, controparti: Controparte[]) {
  if (controparti.length > 0) {
    let filtred = controparti.filter(controparte => controparte.parte.id === option.anagrafica.id)
    option.isControparte = filtred && filtred.length > 0;
  } else {
    option.isControparte = false;
  }
}


export function codiceFiscale(fieldControl: Parte) {
  if (fieldControl.codiceFiscale) {
    const regex = PropertiesSettings.REGEX_CODICE_FISCALE;
    const value = fieldControl.codiceFiscale;
    const regexSymbol = String(value).match(regex);
    return !!(!value || value === '' || regexSymbol);
  }
  return true;
}

export function checkCodiceFiscale(value: String) {
  if (String) {
    const regex = PropertiesSettings.REGEX_CODICE_FISCALE;
    const regexSymbol = String(value).match(regex);
    return !!(!value || value === '' || regexSymbol);
  }
  return true;
}

export function partitaIva(fieldControl: Parte) {
  if (fieldControl.partitaIva) {
    const regex = PropertiesSettings.REGEX_PARTITA_IVA;
    const value = fieldControl.partitaIva;
    return !!(!value || value === '' || (String(value).match(regex)));
  }
  return true;
}

export function isParteAssociable(anagrafica: any): boolean {
  let PROPERTIES_SETTINGS = PropertiesSettings;
  if (anagrafica.tipoPersona) {
    if (anagrafica.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA) {
      return anagrafica.nome && anagrafica.cognome && codiceFiscale(anagrafica) && anagrafica.sesso
    } else if (anagrafica.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA) {
      return anagrafica.ragioneSociale;
    }
  }
  return false;
}

export function areSame(parte1: Parte, parte2: Parte): boolean {
  if (parte1.id === parte2.id) {
    return true;
  }
  return areSameWithoutId(parte1, parte2);
}


export function areSameWithoutId(parte1: Parte, parte2: Parte): boolean {
  let PROPERTIES_SETTINGS = PropertiesSettings;
  if (parte1 !== null && parte2 !== null && parte1.tipoPersona && parte2.tipoPersona && parte1.tipoPersona.label === parte2.tipoPersona.label) {
    if (parte1.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA) {
      let nome1 = parte1.nome ? parte1.nome.trim().toUpperCase() : '';
      let nome2 = parte2.nome ? parte2.nome.trim().toUpperCase() : '';
      let cognome1 = parte1.cognome ? parte1.cognome.trim().toUpperCase() : '';
      let cognome2 = parte2.cognome ? parte2.cognome.trim().toUpperCase() : '';
      let codiceFiscale1 = parte1.codiceFiscale ? parte1.codiceFiscale.trim().toUpperCase() : '';
      let codiceFiscale2 = parte2.codiceFiscale ? parte2.codiceFiscale.trim().toUpperCase() : '';
      let identificativoP1 = nome1 + cognome1 + codiceFiscale1;
      let identificativoP2 = nome2 + cognome2 + codiceFiscale2;
      return identificativoP1 === identificativoP2;
    } else if (parte1.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA) {
      let ragioneSociale1 = parte1.ragioneSociale ? parte1.ragioneSociale.trim().toUpperCase() : '';
      let ragioneSociale2 = parte2.ragioneSociale ? parte2.ragioneSociale.trim().toUpperCase() : '';
      let partitaIva1 = parte1.partitaIva ? parte1.partitaIva.trim().toUpperCase() : '';
      let partitaIva2 = parte2.partitaIva ? parte2.partitaIva.trim().toUpperCase() : '';
      let identificativoP1 = ragioneSociale1 + partitaIva1;
      let identificativoP2 = ragioneSociale2 + partitaIva2;
      return identificativoP1 === identificativoP2;
    }
  }
  return false;
}

export function extractParteEntityFromSearch(tipoPersonaOptions: TipoPersona[], entity: ElaborationDocumentFilterEntity, partiFromSearch: Parte[]): Parte {

  // METODO CHE TIRA FUORI LA PARTE EGENRATA DALLE ENTITY MINERVA SE NON C'è MATCH CON LE PARTI ESTRAPOLTE DALLA RICERCA
  let count = 0;
  let parteEntity = parteFromEntity(entity, tipoPersonaOptions);
  if(partiFromSearch && partiFromSearch.length > 0){
    partiFromSearch.forEach(parteFromSearch =>{
        if(areSameWithoutId(parteFromSearch,parteEntity)){
          count = count + 1;
        }
    });

  }
  if (count === 0) {
    return parteEntity;
  }
  return null;
}

function estraiNomeECognome(valore: string) {
  let regex = /nome:\s*((?:\w+\s*)+)\s+cognome:\s*((?:\w+\s*)+)/i;
  let matches = valore.match(regex);
  return matches
}

function estraiRagioneSociale(valore: string) {
  const regex = /ragioneSociale:\s*(.*)/;
  const matches = valore.match(regex);
  if (matches && matches.length > 1) {
    return matches[1];
  } else {
    return null;
  }
}

export function isDuplicate(parte: Parte, suggeriti: Parte[]) {
  let result = false
  suggeriti.forEach(suggerito => {
    if(areSameWithoutId(parte, suggerito)) {
      result = true;
    }
  })
  return result;
}

